import { render, staticRenderFns } from "./vfg-vspassword.vue?vue&type=template&id=d3bd4c48"
import script from "./vfg-vspassword.vue?vue&type=script&lang=js"
export * from "./vfg-vspassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports